// extracted by css-extract-rspack-plugin
export default {"content":"content--XKQrhNAvZOwmC1B1","image":"image--zRxNrmaMrQ42EYeB"};